import { render, staticRenderFns } from "./stockIntransitBubble.vue?vue&type=template&id=63d6f22a"
import script from "./stockIntransitBubble.vue?vue&type=script&lang=js"
export * from "./stockIntransitBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports